import React from "react";
import { call, mail, map } from "../constant/images";
import ContactForm from "../Components/ContactUs/ContactForm";
import NewsLetter from "../Components/Home/NewsLetter";
import PageBanner from "../Components/PageBanner";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import usePageTracker from "../hooks/usePageTracker";

const ContactUs = () => {
  const { t } = useTranslation(); // Use i18n for translations
  usePageTracker("page_view_contact");

  return (
    <>
      <Helmet>
        <title>{t("seo.contact_title")}</title>
        <meta
          name="description"
          content="Learn more about Online Institute, our mission, our team, and the educational values we bring to your learning experience."
        />
        <meta property="og:title" content="About Us | Online Institute" />
        <meta
          property="og:description"
          content="Explore the story and mission of Online Institute — where online education meets excellence and flexibility."
        />
        <meta
          property="og:image"
          content="https://pre-onlineinstitute.mediafactoryworld.com/assets/images/og-image.jpg"
        />
        <meta
          property="og:url"
          content="https://pre-onlineinstitute.mediafactoryworld.com/about"
        />
        <meta name="twitter:title" content="About Online Institute" />
        <meta
          name="twitter:description"
          content="Discover our values, team, and how we deliver quality education to students across the globe."
        />
      </Helmet>
      <PageBanner
        title={t("contact.title")}
        pageName={t("contact.page_name")}
      />
      <div className="nav-tab-wrapper tabs section-padding">
        <div className="container">
          <div className="grid grid-cols-12 gap-[30px]">
            <div className="xl:col-span-5 lg:col-span-6 col-span-12">
              <div className="mini-title">{t("contact.mini_title")}</div>
              <h4 className="column-title">{t("contact.get_in_touch")} </h4>

              <ul className="list-item space-y-6 pt-8">
                {/* Email */}
                <li className="flex">
                  <div className="flex-none ml-6 mr-6">
                    <img src={mail} alt="Email Icon" />
                  </div>
                  <div className="flex-1">
                    <h4 className="lg:text-xl text-lg mb-1">
                      {t("contact.email_us")}
                    </h4>
                    <div>
                      <a
                        href="mailto:info@onlineinstitute.net"
                        className="text-primary underline hover:text-secondary transition"
                      >
                        info@onlineinstitute.net
                      </a>
                    </div>
                  </div>
                </li>

                {/* Phone */}
                <li className="flex">
                  <div className="flex-none ml-6 mr-6">
                    <img src={call} alt="Call Icon" />
                  </div>
                  <div className="flex-1 ">
                    <h4 className="lg:text-xl mx-8 text-lg mb-1">
                      {t("contact.call_us")}
                    </h4>
                    <div>
                      <a
                        href="tel:+96550761835"
                        className="text-primary underline hover:text-secondary transition"
                        dir="ltr"
                      >
                        +965 507 61835
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="xl:col-span-7 lg:col-span-6 col-span-12">
              <div class="bg-white shadow-box7 p-8 rounded-md">
                <ContactForm />
              </div>
            </div>
            <div className="col-span-12">
              <div className="shadow-box7 p-8 rounded-md">
                <NewsLetter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
